module.exports = __webpack_public_path__ + "img/02.e514e4e5.jpg";